// extracted by mini-css-extract-plugin
export default {"top-container":"FreeDeliveryFastReturn_top-container__qxd18","container":"FreeDeliveryFastReturn_container__l4WnP"};